import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Card, Col, Form, Row, Table } from "react-bootstrap";
import {
  calculateAccruedRevShareForQuarter,
  loadAccrualCalculatorHistory,
  loadCalculableQuarters,
} from "../../../redux/actions/AccrualCalculatorActions";
import RevShareModal from "../../common/overrides/RevShareModal";
import FormRow from "../../common/forms/FormRow";
import SelectInput from "../../common/forms/SelectInput";

const QuarterlyAccrualCard = (props) => {
  const [year, setYear] = useState(NaN);
  const [quarter, setQuarter] = useState(NaN);
  const [lastRun, setLastRun] = useState({ date: "previously", quarter: "" });
  const [selectableYears, setSelectableYears] = useState([]);
  const [selectableQuarters, setSelectableQuarters] = useState([]);

  useEffect(() => {
    props.loadCalculableQuarters();
    props.loadAccrualCalculatorHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (props.runHistory.length > 0) {
      const run = props.runHistory.reduce((a, b) => {
        return new Date(a.MeasureDate) > new Date(b.MeasureDate) ? a : b;
      });
      setLastRun({ date: Date(run.RunOn).toString(), quarter: run.runForQuarter });
    }
  }, [props.runHistory]);

  useEffect(() => {
    setSelectableYears([...new Set(props.calculableQuarters.map((i) => i.year))]);
  }, [props.calculableQuarters]);

  useEffect(() => {
    setSelectableQuarters([...new Set(props.calculableQuarters.filter((i) => i.year === year).map((i) => i.quarter))]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [year, props.calculableQuarters]);

  const runCalculator = () => {
    return props.calculateAccruedRevShareForQuarter(quarter, year);
  };

  return (
    <Card>
      <Card.Header>
        <h3>Quarterly Accrual</h3>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col sm="8">
            <Row>
              <p>
                The Rev Share Calculator is used to process the earned rev share for consultants on a quarterly basis.
                The tool is run for a given quarter and calculates the rev share earned based on the data warehouse time
                cards.
              </p>
              <p>
                The calculator can be run multiple times for a given quarter. After the first run, the calculator will
                only update any calculations that have changed based on time cards added after the previous run, or
                timecard corrections done after the previous run.
              </p>
            </Row>
            <Row>
              <Col sm="auto">
                <p>
                  <strong>The calculator was last run on: {Date.parse(lastRun.date)}</strong>
                </p>
                <p>
                  <strong>The calculator was last run for: Q{lastRun.quarter}</strong>
                </p>
              </Col>
              <Col>
                <RevShareModal
                  buttonText="Run History"
                  buttonVariant="secondary"
                  hideYesButton
                  noButtonText="Close"
                  title="Accrual Calculator Run History"
                >
                  <Table>
                    <thead>
                      <tr key="accrualHistoryTableHead">
                        <th>Run By</th>
                        <th>Run On</th>
                        <th>Run For</th>
                      </tr>
                    </thead>
                    <tbody>
                      {props.runHistory.map((i) => (
                        <tr key={`accrualHistoryTableRow_${i.RunOn}`}>
                          <td>{i.runByName}</td>
                          <td>{Date.parse(i.RunOn).toString()}</td>
                          <td>{`Q${i.runForQuarter} ${i.runForYear}`}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </RevShareModal>
              </Col>
            </Row>
          </Col>
          <Col sm="4">
            <Form>
              <FormRow
                columns={[
                  <SelectInput
                    label="Year"
                    onChange={(event) => setYear(parseInt(event.target.value))}
                    options={selectableYears}
                  />,
                  <SelectInput
                    disabled={isNaN(year)}
                    label="Quarter"
                    onChange={(event) => setQuarter(parseInt(event.target.value))}
                    options={selectableQuarters}
                  />,
                ]}
              />
              <RevShareModal
                buttonText="Run"
                buttonVariant="primary"
                modalSize="sm"
                selfClosing
                title="Confirm Run"
                yesButtonOnClick={() => runCalculator()}
                yesButtonText="Run"
              >
                <p>
                  Are you sure you want to run the accrual calculator for Q{quarter} {year}?
                </p>
              </RevShareModal>
            </Form>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    calculableQuarters: state.calculableAccrualQuarters,
    runHistory: state.accrualCalculatorHistory,
  };
};

const mapDispatchToProps = {
  calculateAccruedRevShareForQuarter,
  loadAccrualCalculatorHistory,
  loadCalculableQuarters,
};

export default connect(mapStateToProps, mapDispatchToProps)(QuarterlyAccrualCard);
